/**
 * Impact Theme Custom JS
 * 1. Font Awesome Block
 * 2. Hover Slide Animation
 * 3. External Link Handler
 * 4. Global Lifecycle Manager (incl. Zepto cart drawer refresh)
 * 5. Consent Checkbox
 * 6. Gift Wrapping (Cart Drawer)
 * 7. Size Chart Unit Toggle (cm / inch)
 * 8. Password Gate
 * Custom order / Zepto blocks live in assets/custom-order.js
 */


(function () {
    // 1. Font Awesome Block
    (function() {
        if (window.__faS || typeof window.jQuery === 'undefined' || !window.jQuery.fn.append) return;
        window.__faS = true;
        const originalAppend = window.jQuery.fn.append;
        window.jQuery.fn.append = function() {
            if (arguments.length === 0) return originalAppend.apply(this, arguments);
            const args = Array.from(arguments).map(arg => {
                if (typeof arg !== 'string') return arg;
                if (arg.includes('font-awesome') || arg.includes('fontawesome')) {
                    return ''; 
                }
                if (arg.includes('pFontAwesome')) {
                    return arg.replace(/@font-face\s*\{[^}]*pFontAwesome[^}]*\}/gi, '');
                }  
                return arg;
            });
            return originalAppend.apply(this, args);
        };
    })();

    // 2. Hover Slide Animation
    const initHoverSlide = () => {
        const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouchDevice) return;
        document.querySelectorAll(".hover-slide").forEach((hoverSlideDiv) => {
            const element = hoverSlideDiv.closest("a:not([disabled]), button:not([disabled])");
            if (!element || element.dataset.hoverSlideInit) return;
            element.dataset.hoverSlideInit = "true";
            const span = hoverSlideDiv.querySelector("span");
            if (!span) return;
            let isAnimating = false;
            let cloneSpan = null;
            const startAnimation = () => {
                if (isAnimating || element.hasAttribute('disabled')) return;
                isAnimating = true;
                const spanRect = span.getBoundingClientRect();
                const hoverSlideDivRect = hoverSlideDiv.getBoundingClientRect();
                cloneSpan = span.cloneNode(true);
                cloneSpan.style.position = "absolute";
                cloneSpan.style.left = `${spanRect.left - hoverSlideDivRect.left}px`;
                cloneSpan.style.top = `${spanRect.top - hoverSlideDivRect.top}px`;
                cloneSpan.style.width = `${spanRect.width}px`;
                cloneSpan.style.height = `${spanRect.height}px`;
                cloneSpan.style.transform = "translateY(100%)";
                cloneSpan.style.transition = "transform 0.6s cubic-bezier(0.4, 0, 0, 1)";
                hoverSlideDiv.appendChild(cloneSpan);
                span.style.transform = "translateY(-100%)";
                span.style.transition = "transform 0.6s cubic-bezier(0.4, 0, 0, 1)";
                setTimeout(() => { requestAnimationFrame(() => { if (cloneSpan) cloneSpan.style.transform = "translateY(0)"; }); }, 50);
            };
            const resetAnimation = () => {
                if (!isAnimating) return;
                span.style.transform = "translateY(0)";
                if (cloneSpan) {
                    cloneSpan.style.transform = "translateY(100%)";
                    cloneSpan.addEventListener("transitionend", () => {
                        if (cloneSpan) { cloneSpan.remove(); cloneSpan = null; }
                        isAnimating = false;
                    }, { once: true });
                } else { isAnimating = false; }
            };
            element.addEventListener("mouseenter", startAnimation, false);
            element.addEventListener("mouseleave", resetAnimation, false);
        });
    };

    // 3. External Link Handler
    const initExternalLinks = () => {
        document.querySelectorAll('a[href^="http"], a[href^="/"]').forEach(link => {
            if ((link.protocol === 'http:' || link.protocol === 'https:') && link.hostname !== window.location.hostname) {
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.setAttribute('data-external', 'true');
            }
        });
    };

    // 4. Global Lifecycle Manager (incl. Zepto cart drawer refresh)
    function mainInit() {
        initHoverSlide();
        initExternalLinks();
    }

    if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", mainInit); } else { mainInit(); }
    document.addEventListener("shopify:section:load", mainInit);

    window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
            document.querySelectorAll('[data-hover-slide-init]').forEach(el => {
                delete el.dataset.hoverSlideInit;
            });
            mainInit();
            setTimeout(() => { if (typeof window.pplr_cart_item_config === 'function') window.pplr_cart_item_config(!0); }, 500);
        }
    });

    document.documentElement.addEventListener("cart:change", () => {
        setTimeout(() => {
            if (typeof window.pplr_cart_item_config === 'function') window.pplr_cart_item_config(!0);
        }, 1350);
    });
})();

// 5. Consent Checkbox
(function () {
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('[is="product-form"]')) return;
    const wrapper = form.querySelector('.consent-checkbox-wrapper');
    if (!wrapper) return;
    const unchecked = Array.from(wrapper.querySelectorAll('.consent-checkbox:not(:checked)'));
    if (unchecked.length === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    unchecked.forEach(cb => cb.setAttribute('aria-invalid', 'true'));
    const errorEl = form.querySelector('.consent-checkbox-error');
    if (errorEl) errorEl.hidden = false;
  }, { capture: true });

  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('consent-checkbox')) return;
    if (e.target.checked) e.target.removeAttribute('aria-invalid');
    const form = e.target.closest('[is="product-form"]');
    if (!form) return;
    const wrapper = form.querySelector('.consent-checkbox-wrapper');
    const errorEl = form.querySelector('.consent-checkbox-error');
    if (!errorEl || errorEl.hidden) return;
    if (!wrapper.querySelector('.consent-checkbox:not(:checked)')) errorEl.hidden = true;
  });
})();

// 6. Gift Wrapping (Cart Drawer)
(function () {
  if (customElements.get('gift-wrapping')) return;

  function cartUpdate(body) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) return false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return true;
    });
  }

  var GiftWrapping = class extends HTMLElement {
    connectedCallback() {
      this.variantId = parseInt(this.dataset.variantId, 10);
      if (!this.variantId) return;
      if (this.reconcile()) return;
      this.addEventListener('change', this.onChange.bind(this));
    }

    addWrap() {
      return cartUpdate({ updates: this.wrapUpdate(1), attributes: { 'gift-wrapping': true } });
    }

    removeWrap() {
      return cartUpdate({ updates: this.wrapUpdate(0), attributes: { 'gift-wrapping': '', 'gift-note': '' } });
    }

    wrapUpdate(qty) {
      var updates = {};
      updates[this.variantId] = qty;
      return updates;
    }

    onChange(event) {
      var target = event.target;
      if (target.name === 'attributes[gift-wrapping]') {
        var request = target.checked ? this.addWrap() : this.removeWrap();
        request.then(function (ok) {
          if (!ok) target.checked = !target.checked;
        });
      } else if (target.id === 'gift-note') {
        cartUpdate({ attributes: { 'gift-note': target.value } });
      }
    }

    reconcile() {
      var qty = parseInt(this.dataset.qtyInCart, 10) || 0;
      var itemsSize = parseInt(this.dataset.cartItemsSize, 10) || 0;
      var attrSet = this.dataset.attributeSet === 'true';

      if (itemsSize === 1 && qty > 0) { this.removeWrap(); return true; }
      if (qty > 1) { this.addWrap(); return true; }
      if (qty > 0 && !attrSet) { this.addWrap(); return true; }
      if (qty === 0 && attrSet) { this.addWrap(); return true; }
      return false;
    }
  };

  customElements.define('gift-wrapping', GiftWrapping);
})();

// 7. Size Chart Unit Toggle (cm / inch)
(function () {
  if (customElements.get('size-chart-unit')) return;

  var STORAGE_KEY = 'rmfc:size-chart-unit';
  var EVENT_NAME = 'size-chart:unit-change';
  var NUMBER_PATTERN = /\d+(?:\.\d+)?/g;

  function readUnit() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'inch' ? 'inch' : 'cm';
    } catch (e) {
      return 'cm';
    }
  }

  function saveUnit(unit) {
    try {
      localStorage.setItem(STORAGE_KEY, unit);
    } catch (e) {}
  }

  function cmToInch(cm) {
    return String(Math.round((cm / 2.54) * 10) / 10);
  }

  var SizeChartUnit = class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      var signal = this.abortController.signal;

      this.scope = this.closest('x-drawer') || this;
      this.scope.addEventListener('change', this.onChange.bind(this), { signal: signal });
      document.addEventListener(EVENT_NAME, this.onUnitChange.bind(this), { signal: signal });

      this.render(readUnit());
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    onChange(event) {
      if (!event.target.matches('[data-unit-switch]')) return;

      var unit = event.target.checked ? 'inch' : 'cm';
      saveUnit(unit);
      document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { unit: unit } }));
    }

    onUnitChange(event) {
      this.render(event.detail.unit);
    }

    render(unit) {
      this.scope.dataset.unit = unit;

      this.scope.querySelectorAll('[data-unit-switch]').forEach(function (input) {
        input.checked = unit === 'inch';
      });

      this.querySelectorAll('[data-cm]').forEach(function (cell) {
        var cm = cell.dataset.cm;
        cell.textContent = unit === 'inch'
          ? cm.replace(NUMBER_PATTERN, function (match) { return cmToInch(parseFloat(match)); })
          : cm;
      });
    }
  };

  customElements.define('size-chart-unit', SizeChartUnit);
})();

// 8. Password Gate
(function () {
  var form = document.querySelector('[data-password-gate]');
  if (!form) return;

  var ATTRIBUTE = '_password_gate';
  var MAX_HASHES = 5;
  var ATTEMPT_KEY = 'password-gate-attempt';
  var ATTEMPT_TTL = 60 * 1000;

  var productId = form.dataset.passwordGate;
  var input = form.querySelector('input[name="password"]');
  var button = form.querySelector('button[type="submit"]');
  var wrongEl = form.querySelector('[data-password-gate-wrong]');
  var errorEl = form.querySelector('[data-password-gate-error]');

  function readAttempt() {
    try {
      var raw = sessionStorage.getItem(ATTEMPT_KEY);
      sessionStorage.removeItem(ATTEMPT_KEY);
      var attempt = raw ? JSON.parse(raw) : null;
      return attempt && attempt.id === productId && Date.now() - attempt.at < ATTEMPT_TTL;
    } catch (e) {
      return false;
    }
  }

  function writeAttempt() {
    try {
      sessionStorage.setItem(ATTEMPT_KEY, JSON.stringify({ id: productId, at: Date.now() }));
    } catch (e) {}
  }

  function toHex(buffer) {
    return Array.from(new Uint8Array(buffer)).map(function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
  }

  function sha256(text) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(text)).then(toHex);
  }

  function setBusy(busy) {
    form.dataset.busy = busy ? 'true' : '';
    if (button) {
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
    }
  }

  function fetchJson(path, options) {
    return fetch(window.Shopify.routes.root + path, options).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  function mergeHashes(current, hash) {
    var hashes = String(current || '').split(',').filter(function (item) {
      return item && item !== hash;
    });
    hashes.push(hash);
    return hashes.slice(-MAX_HASHES).join(',');
  }

  if (wrongEl && readAttempt()) wrongEl.hidden = false;

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    if (form.dataset.busy === 'true') return;

    var value = input ? input.value.trim() : '';
    if (!value) return;

    setBusy(true);
    if (wrongEl) wrongEl.hidden = true;
    if (errorEl) errorEl.hidden = true;

    var hash;
    sha256(value).then(function (result) {
      hash = result;
      return fetchJson('cart.js');
    }).then(function (cart) {
      var attributes = {};
      attributes[ATTRIBUTE] = mergeHashes(cart.attributes && cart.attributes[ATTRIBUTE], hash);
      return fetchJson('cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    }).then(function () {
      if (input) input.blur();
      writeAttempt();
      window.location.reload();
    }).catch(function () {
      setBusy(false);
      if (errorEl) errorEl.hidden = false;
    });
  });
})();
